import React, {useEffect, useState} from "react";
import axios from "axios";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from 'yup';
import "./DashboardApplicationComponent.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import {useLocation, useNavigate} from 'react-router-dom';
import Select from "react-select";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import {FaAsterisk, FaCalendarAlt, FaInfoCircle, FaPlus, FaSearch} from "react-icons/fa";
import {ka} from 'date-fns/locale';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {format} from 'date-fns';
import LocationProps from "../../../enums/LocationProps";
import {Alert, Chip, Snackbar, Tooltip, Button} from "@mui/material";
import nomenclatureEnum from "../../../enums/nomenclatureEnum";
import ExcelPopup from "../../apiTables/ExcelPopup";
import InfoPopup from "./InfoPopup";
import {MdClose} from "react-icons/md";
import countries from 'i18n-iso-countries';
import geo from 'i18n-iso-countries/langs/ka.json';
import {jwtDecode} from "jwt-decode";

const DashboardApplicationComponent = ({geoIds}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const urlParams = new URLSearchParams(window.location.search);
    const permitTypeIdFromUrl = parseInt(urlParams.get('id'), 10);
    const [validationSchema, setValidationSchema] = useState(null);
    const [municipalities, setMunicipalities] = useState([]);
    const [regions, setRegions] = useState([]);
    const [councils, setCouncils] = useState([]);
    const [populatedAreas, setPopulatedAreas] = useState([]);
    const [title, setTitle] = useState("");
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [formDataToSubmit, setFormDataToSubmit] = useState(null);
    const [inputTypes, setInputTypes] = useState([]);
    const [dropdownOptions, setDropdownOptions] = useState({});
    const [isAccelerationChecked, setIsAccelerationChecked] = useState(false);
    const [isCompanyDataLoading, setIsCompanyDataIsLoading] = useState(false);
    const [isCadastralCodeLoading, setIsCadastralCodeIsLoading] = useState(false);
    const [permitTypePricings, setPermitTypePricings] = useState([]);
    const [selectedPermitTypePriceId, setSelectedPermitTypePriceId] = useState(null);
    const [showAccelerationCheckbox, setShowAccelerationCheckbox] = useState(false);
    const [generateFormik, setGenerateFormik] = useState(false);
    const [companyInfo, setCompanyInfo] = useState({});
    const [objectOwnerInfo, setObjectOwnerInfo] = useState({});
    const [boomBoomOwnerInfo, setBoomBoomOwnerInfo] = useState({});
    const [exploitationCompanyInfo, setExploitationCompanyInfo] = useState({});
    const [alert, setAlert] = useState({message: '', severity: 'info'});
    const [showAlert, setShowAlert] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [info, setInfo] = useState('');
    const [infoTitle, setInfoTitle] = useState('');
    const [caseData, setCaseData] = useState(null)
    const [parentCaseData, setParentCaseData] = useState(null)
    const [hasBuilidngDocument, setHasBuilidngDocument] = useState(null)
    const [userIp, setUserIp] = useState('214124');
    const [lastName, setLastName] = useState('');
    const [lastNameExp, setLastNameExp] = useState('');
    const [personalNumber, setPersonalNumber] = useState('');
    const [personalNumberExp, setPersonalNumberExp] = useState('');
    const [cadastralCodeArray, setCadastralCodeArray] = useState([]);
    const [cadastralCode, setCadastralCode] = useState('');
    const [isObjectInfoButtonDisabled, setIsObjectInfoButtonDisabled] = useState(true);
    const [isExplanationInfoButtonDisabled, setIsExplanationInfoButtonDisabled] = useState(true);
    const [isBoomBoomInfoButtonDisabled, setIsBoomBoomInfoButtonDisabled] = useState(true);
    const [isCompanyInfoButtonDisabled, setIsCompanyInfoButtonDisabled] = useState(true);
    const [objectOwnerValidationEnabled, setObjectOwnerValidationEnabled] = useState(true);
    const [exploitationCompanyValidationEnabled, setExploitationCompanyValidationEnabled] = useState(true);
    const [boomBoomOwnerValidationEnabled, setBoomBoomOwnerValidationEnabled] = useState(true);
    const [companyValidationEnabled, setCompanyValidationEnabled] = useState(true);
    const [caseHasExploitationField, setCaseHasExploitationField] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const entity = params?.get('entity') ?? '';
    const explanationEntity = params?.get('explanationEntity') ?? '';
    const isLegal = entity === 'legal';
    const isLegalExplanation = explanationEntity === 'legal';
    const isSelfCustomer = entity === 'self_customer';
    const isSelfCustomerExplanation = explanationEntity === 'without_exploitation';
    const isPhysical = entity === 'physical';
    const isPhysicalExplanation = explanationEntity === 'physical';
    const isAssociation = entity === 'association';
    const isAssociationExplanation = explanationEntity === 'association';
    const isForeigner = entity === 'foreigner';
    const isForeignerExplanation = explanationEntity === 'foreigner';
    const [userId, setUserId] = useState("");
    const token = localStorage.getItem("jwtToken");
    const [userData, setUserData] = useState({
        firstName: "",
        lastName: "",
        pNumber: "",
        orgNumber: "",
        orgName: "",
        email: ""
    });
    const [userFirstName, setUserFirstName] = useState("");
    const [userFirstNameExp, setUserFirstNameExp] = useState("");
    const [creteByExpertCaseNumber, setCreteByExpertCaseNumber] = useState(false);
    const [isUserDataIsLoading, setIsUserDataIsLoading] = useState(false);
    const isMobile = window.innerWidth < 768
    const [initialValues, setInitialValues] = useState({
        cadastralCode: '',
        objectName: '',
        address: '',
        municipalityId: [],
        regionId: [],
        councilId: [],
        populatedAreaId: [],
        parentId: '',
        creteByExpertCaseNumber: false,
        oldCaseNumber: '',
        personalNumber: '',
        personalNumberExplanation: '',
        firstName: '',
        firstNameExplanation: '',
        lastName: '',
        lastNameExplanation: '',
        clientName: '',
        clientNameExplanation: '',
        legalAddress: '',
        legalAddressExplanation: '',
        identificationNumberForAssociation: '',
        identificationNumberForAssociationExplanation: '',
        country: '',
        countryExplanation: '',
        passportNumber: '',
        passportNumberExplanation: '',
        foreignerName: '',
        foreignerNameExplanation: '',
        foreignerAddress: '',
        foreignerAddressExplanation: '',
    });

    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                setUserRole("");
            } finally {
            }
        }
    }, [token]);

    countries.registerLocale(geo);

    const countryNames = countries.getNames('ka', {select: 'official'});

    const countryOptions = Object.entries(countryNames).map(([code, name]) => ({
        value: code,
        label: name,
    }));


    useEffect(() => {
        setCaseHasExploitationField(inputTypes.some(inputType => inputType.title === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი"));
    }, [inputTypes]);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserId(decoded.UserId);
            } catch (error) {
                setUserId("");
            }
        }
    }, [token]);

    useEffect(() => {
        console.log(isForeigner)
        console.log(isForeignerExplanation)
    }, [isForeignerExplanation, isForeigner]);

    useEffect(() => {
        const fetchUserData = async () => {
            if (userId && token) {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`
                    );
                    if (response.data.success) {
                        setUserData(
                            {
                                firstName: response.data.data.isOorganisation !== true ? response.data.data.firstName : '',
                                lastName: response.data.data.isOorganisation !== true ? response.data.data.lastName : '',
                                pNumber: response.data.data.isOorganisation !== true ? response.data.data.pNumber : '',
                                orgNumber: response.data.data.isOorganisation !== false ? response.data.data.orgNumber : '',
                                orgName: response.data.data.isOorganisation !== false ? response.data.data.orgName : '',
                                email: isSelfCustomer ? response.data.data.email : '',
                            }
                        );
                    } else {
                        setUserData({
                            firstName: "",
                            lastName: "",
                            pNumber: "",
                            orgNumber: "",
                            orgName: "",
                        });
                    }
                } catch (error) {
                    setUserData({
                        firstName: "",
                        lastName: "",
                        pNumber: "",
                        orgNumber: "",
                        orgName: "",
                    });
                }
            }
        };

        void fetchUserData();
    }, [userId, token]);


    function generateObjectOwner(caseId, value) {

        return [
            {
                caseDetailInfo: {
                    caseId: parseInt(caseId, 10),
                    key: 'ობიექტის მფლობელის დასახელება',
                    value: value,
                    inputType: 3,
                    dictionaryTypeId: null,
                    dictionaryId: null,
                    hasDeadline: false,
                    hasFile: false,
                    unicId: false,
                    visibleOnTable: false,
                    visibleOnTableForUser: false,
                    isIdentificationNumber: false
                }
            },

        ];
    }

    function generateObjectOwnerExp(caseId, value) {

        return [
            {
                caseDetailInfo: {
                    caseId: parseInt(caseId, 10),
                    key: 'ობიექტის ექსპლუატაციის გამწევი პირის დასახელება',
                    value: value,
                    inputType: 3,
                    dictionaryTypeId: null,
                    dictionaryId: null,
                    hasDeadline: false,
                    hasFile: false,
                    unicId: false,
                    visibleOnTable: false,
                    visibleOnTableForUser: false,
                    isIdentificationNumber: false
                }
            },

        ];
    }


    function generateAdditionalCaseDetails(source, caseId, unicPrefix) {
        if (!source || Object.keys(source).length === 0) return [];

        let keys

        if (unicPrefix === "companyInfo") {
            keys = {
                "idNumber": "საიდენტიფიკაციო ნომერი",
                "name": "სახელი",
                "address": "მისამართი"
            };
        } else if (unicPrefix === "objectOwnerInfo") {
            keys = {
                "idNumber": "ობიექტის მფლობელის საიდენტიფიკაციო კოდი",
                "name": "ობიექტის მფლობელის დასახელება",
                "address": "ობიექტის მფლობელის იურიდიული მისამართი"
            };
        } else if (unicPrefix === "boomBoomOwnerInfo") {
            keys = {
                "idNumber": "საიდენტიფიკაციო ნომერი",
                "name": "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია",
                "address": "ორგანიზაციის იურიდიული მისამართი"
            };
        } else if (unicPrefix === "exploitationCompanyInfo") {
            keys = {
                "idNumber": "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი",
                "name": "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება",
                "address": "ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი"
            };
        }

        return [
            {
                caseDetailInfo: {
                    caseId: parseInt(caseId, 10),
                    key: keys["idNumber"],
                    value: source.idNumber ? source.idNumber.toString() : "",
                    inputType: 3,
                    dictionaryTypeId: null,
                    dictionaryId: null,
                    hasDeadline: false,
                    hasFile: false,
                    unicId: false,
                    visibleOnTable: false,
                    visibleOnTableForUser: false,
                    isIdentificationNumber: false
                }
            },
            {
                caseDetailInfo: {
                    caseId: parseInt(caseId, 10),
                    key: keys["name"],
                    value: source.name ? source.name : "",
                    inputType: 3,
                    dictionaryTypeId: null,
                    dictionaryId: null,
                    hasDeadline: false,
                    hasFile: false,
                    unicId: false,
                    visibleOnTable: true,
                    visibleOnTableForUser: true,
                    isIdentificationNumber: false
                }
            },
            {
                caseDetailInfo: {
                    caseId: parseInt(caseId, 10),
                    key: keys["address"],
                    value: source.address ? source.address : "",
                    inputType: 3,
                    dictionaryTypeId: null,
                    dictionaryId: null,
                    hasDeadline: false,
                    hasFile: false,
                    unicId: false,
                    visibleOnTable: false,
                    visibleOnTableForUser: false,
                    isIdentificationNumber: false
                }
            }
        ];
    }


    useEffect(() => {
        if (inputTypes.length !== 0) {
            const objectInfoInput = inputTypes.find(inputType => inputType.title === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი" && inputType.integration === 1);
            const explicitObjectInfoInput = inputTypes.find(inputType => inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი" && inputType.integration === 1);
            const boomBoomOwnerInfoInput = inputTypes.find(inputType => inputType.title === "საიდენტიფიკაციო ნომერი" && inputType.integration === 1);
            const regularInfoInput = inputTypes.find(inputType =>
                (inputType.title !== "ობიექტის მფლობელის საიდენტიფიკაციო კოდი"
                    && inputType.title !== "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი"
                    && inputType.title !== "საიდენტიფიკაციო ნომერი")
                && inputType.integration === 1);

            if (objectInfoInput && Object.keys(objectOwnerInfo).length === 0) {
                setIsObjectInfoButtonDisabled(true);
            } else {
                setIsObjectInfoButtonDisabled(false);
            }
            if (explicitObjectInfoInput && Object.keys(exploitationCompanyInfo).length === 0) {
                setIsExplanationInfoButtonDisabled(true);
            } else {
                setIsExplanationInfoButtonDisabled(false);
            }
            if (boomBoomOwnerInfoInput && Object.keys(boomBoomOwnerInfo).length === 0) {
                setIsBoomBoomInfoButtonDisabled(true);
            } else {
                setIsBoomBoomInfoButtonDisabled(false);
            }
            if (regularInfoInput && Object.keys(companyInfo).length === 0) {
                setIsCompanyInfoButtonDisabled(true);
            } else {
                setIsCompanyInfoButtonDisabled(false);
            }
        }
    }, [inputTypes, objectOwnerInfo, exploitationCompanyInfo, boomBoomOwnerInfo, companyInfo]);
    const handleCloseDialog = () => {
        setDialogOpen(false);
    };
    const handleOpenDialog = (info, infoTitle) => {
        setInfo(info);
        setInfoTitle(infoTitle);
        setDialogOpen(true);
    };


    const autoSubmitInternalInputs = async (caseId) => {
        const urlParams = new URLSearchParams(window.location.search);
        const parentId = urlParams.get('parentId');
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetInputTypesByCaseID?CaseId=${parentId}`);
            const internalInputs = response.data.data.list.filter(input => input.internal === true);

            if (internalInputs.length > 0) {

                const caseDetails = internalInputs.map(input => ({
                    caseDetailInfo: {
                        caseId: parseInt(caseId, 10),
                        key: input.title,
                        value: '',
                        inputType: 5,
                        dictionaryTypeId: input.value === '' ? null : input.value,
                        dictionaryId: null,
                        hasDeadline: input.hasDeadline,
                        hasFile: input.hasFile,
                        visibleOnTable: true,
                        visibleOnTableForUser: false
                    },
                }));
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseDetails`, {caseDetails});
            } else {
            }
        } catch (error) {
        }

    };

    const regionOptions = regions.map(region => ({value: region.id, label: region.itemName}));
    const councilsOptions = councils.map(council => ({value: council.id, label: council.typesName}));
    const populatedAreasOptions = populatedAreas.map(populatedArea => ({
        value: populatedArea.id,
        label: populatedArea.typesName
    }));
    const municipalitiesOptions = municipalities.map(municipality => ({
        value: municipality.id,
        label: municipality.typesName
    }));

    const formatGeoData = (ids) => {
        return ids.map(id => `-${id}-`).join(",") + ",";
    };

    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeByID?Id=${permitTypeIdFromUrl}`);
            setCaseData(response.data.data);
            setTitle(response.data.data.title);
            setHasBuilidngDocument(!!response.data.data.hasBuilidngDocument);
        } catch (error) {
        }
    };
    useEffect(() => {
        if (permitTypeIdFromUrl) {
            void fetchPermitType();
        }
    }, [permitTypeIdFromUrl]);

    const fetchCadastralCode = async (cadastralCode) => {
        if (!cadastralCode) {
            return;
        }
        setIsCadastralCodeIsLoading(true);
        try {
            const response = await axios.get(`https://tcsa.gov.ge/api/GetCADCodeByCadastralCode?CadastralCode=${cadastralCode}`);
            if (response.data.success) {
                if (response.data.success) {
                    setCadastralCodeArray(prevArray => {
                        if (!prevArray.includes(cadastralCode)) {
                            setCadastralCode('');
                            setAlert({message: 'ოპერაცია წარმატებით დასრულდა!', severity: 'success'});
                            return [...prevArray, cadastralCode];
                        } else {
                            setAlert({message: 'საკადასტრო კოდი უკვე დამატებულია სიაში!', severity: 'warning'});
                            return prevArray;
                        }
                    });

                } else {
                    setAlert({message: 'საკადასტრო კოდი არ არსებობს!', severity: 'warning'});
                }
            } else if (!response.data.success) {
                const errorMessage = response.data.errors.message || 'საკადასტრო კოდი არასწორია';
                setAlert({message: errorMessage, severity: 'error'});
            } else {
                setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
            }
        } catch (error) {
            setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
        }
        setIsCadastralCodeIsLoading(false);
        setShowAlert(true);
    };

    const fetchCompanyInfo = async (identificationNumber, fieldName) => {
        setIsCompanyDataIsLoading(true);
        try {
            const response = await axios.get(`https://tcsa.gov.ge/api/NAPR_ENREGWS_GetSubjByIdNrQuery?identificationNumber=${identificationNumber}&SettingEndpointKeyWord=GetSubjByIdNrQuery&ipAddress=${userIp}`);
            if (response.data.success) {
                const data = response.data.data;
                if (data.name || data.status) {
                    if (fieldName === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი") {
                        setObjectOwnerValidationEnabled(true)
                        setObjectOwnerInfo({...data, idNumber: identificationNumber})
                    } else if (fieldName === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი") {
                        setExploitationCompanyValidationEnabled(true)
                        setExploitationCompanyInfo({...data, idNumber: identificationNumber})
                    } else if (fieldName === "საიდენტიფიკაციო ნომერი") {
                        setBoomBoomOwnerValidationEnabled(true)
                        setBoomBoomOwnerInfo({...data, idNumber: identificationNumber})
                    } else {
                        setCompanyValidationEnabled(true)
                        setCompanyInfo({...data, idNumber: identificationNumber});
                    }
                    setAlert({message: 'ოპერაცია წარმატებით დასრულდა', severity: 'success'});
                } else {
                    setCompanyInfo({});
                    setAlert({message: 'არაფერი მოიძებნა!', severity: 'warning'});
                }

            } else if (response.data.success === false) {
                setCompanyInfo({});
                setAlert({
                    message: response.data.errors[0]?.message || 'An unknown error occurred',
                    severity: 'error'
                });
            }


        } catch (error) {
            setCompanyInfo({});
            setAlert({message: 'დაფიქსირდა შეცდომა', severity: 'error'});
        }
        setIsCompanyDataIsLoading(false);
        setShowAlert(true);
    };

    const removeDataFromIntegrationFields = (fieldName) => {
        if (fieldName === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი") {
            setObjectOwnerInfo({})
        } else if (fieldName === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი") {
            setExploitationCompanyInfo({})
        } else if (fieldName === "საიდენტიფიკაციო ნომერი") {
            setBoomBoomOwnerInfo({})
        } else {
            setCompanyInfo({});
        }
    };

    const verifyPrivateNumber = async (userPrivateNumber, userSurname, isExp = false) => {
        setIsUserDataIsLoading(true)
        setAlert({
            message: "",
            severity: "error",
        });
        try {

            const response = await axios.get(
                `https://tcsa.gov.ge/api/GetPhisicalPersonInfo?PrivateNumber=${userPrivateNumber}&LastName=${userSurname}&SettingEndpointKeyWord=GetPhisicalPersonInfo&ipAddress=${userIp}`
            );
            if (response.data && response.data.success) {
                const userData = response.data.data;
                if (userData && userData.firstName) {
                    if (isExp) {
                        setUserFirstNameExp(userData.firstName)
                    } else {
                        setUserFirstName(userData.firstName);
                    }

                    setAlert({
                        message: "ოპერაცია წარტმატებით დასრულდა!",
                        severity: 'info',
                    });
                    setShowAlert(true);
                } else {
                    setAlert({
                        message: "პირადი ნომერი ან გვარი არასწორია!",
                        severity: "error",
                    });
                    setShowAlert(true);
                    if (isExp) {
                        setUserFirstNameExp('')
                    } else {
                        setUserFirstName('');
                    }
                }
            } else {
                setAlert({
                    message: "პირადი ნომერი ან გვარი არასწორია!",
                    severity: "error",
                });
                setShowAlert(true)
                if (isExp) {
                    setUserFirstNameExp('')
                } else {
                    setUserFirstName('');
                }
            }
        } catch (error) {
            setAlert({
                message: "დაფიქრიდა შეცოდმა",
                severity: "error",
            });
            setShowAlert(true)
            if (isExp) {
                setUserFirstNameExp('')
            } else {
                setUserFirstName('');
            }
        } finally {
            setIsUserDataIsLoading(false);
        }
    };

    useEffect(() => {
        if (userFirstName !== '') {
            setAlert({
                message: "საჭიროა მონაცემების განახლება!",
                severity: "error",
            });
            setShowAlert(true)
        }

        setUserFirstName('')


    }, [personalNumber, lastName]);

    useEffect(() => {
        if (userFirstNameExp !== '') {
            setAlert({
                message: "საჭიროა მონაცემების განახლება!",
                severity: "error",
            });
            setShowAlert(true)
        }

        setUserFirstNameExp('')


    }, [personalNumberExp, lastNameExp]);

    useEffect(() => {
        const fetchPermitTypePricings = async () => {
            try {
                if (isAccelerationChecked) {
                    const response = await axios.get(`${baseURL}/GetPermitTypePricings`);
                    if (response.data.success) {
                        const filteredPricings = response.data.data.filter(p => p.permitId === permitTypeIdFromUrl);
                        setPermitTypePricings(filteredPricings);
                    }
                } else {
                    setPermitTypePricings([]);
                    setSelectedPermitTypePriceId(null);
                }
            } catch (error) {
            }
        };

        void fetchPermitTypePricings();
    }, [isAccelerationChecked]);


    useEffect(() => {
        const fetchDropdownOptions = async () => {
            const fetchedDropdownOptions = {};
            for (const inputType of inputTypes) {
                if (inputType.type === 1) {
                    try {
                        const response = await axios.get(`${baseURL}/DictionaryTypesDetalisById?CategoryId=${inputType.valueId}`);
                        if (response.data.success) {
                            fetchedDropdownOptions[inputType.title] = response.data.data.resultlist.map(item => ({
                                value: item.id,
                                label: item.itemName
                            }));
                        }
                    } catch (error) {
                    }
                }
            }
            setDropdownOptions(fetchedDropdownOptions);
        };

        if (inputTypes.length > 0) {
            void fetchDropdownOptions();
        }
    }, [inputTypes]);


    const getPermitTypeIdFromURL = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('id');
    };


    useEffect(() => {
        const updatedInitialValues = inputTypes.reduce((acc, inputType) => {
            acc[inputType.title] = inputType.valueId || '';
            return acc;
        }, {
            cadastralCode: '',
            objectName: '',
            address: '',
            municipalityId: [],
            regionId: [],
            councilId: [],
            populatedAreaId: [],
            parentId: '',
            request: '',
            personalNumber: '',
            personalNumberExplanation: '',
            firstName: '',
            firstNameExplanation: '',
            lastName: '',
            lastNameExplanation: '',
            clientName: '',
            clientNameExplanation: '',
            legalAddress: '',
            legalAddressExplanation: '',
            identificationNumberForAssociation: '',
            identificationNumberForAssociationExplanation: '',
            country: '',
            countryExplanation: '',
            passportNumber: '',
            passportNumberExplanation: '',
            foreignerName: '',
            foreignerNameExplanation: '',
            foreignerAddress: '',
            foreignerAddressExplanation: '',
        });

        setInitialValues(updatedInitialValues);
    }, [inputTypes]);


    useEffect(() => {


        setValidationSchema(Yup.object().shape({
                municipalityId: Yup.array()
                    .of(Yup.number())
                    .min(1, 'სავალდებულო')
                    .required('სავალდებულო'),
                regionId: Yup.array()
                    .of(Yup.number())
                    .min(1, 'სავალდებულო')
                    .required('სავალდებულო'),
                address: Yup.string().required('სავალდებულო'),


                ...(isPhysical && {
                    personalNumber: Yup.string()
                        .required('სავალდებულო')
                        .matches(/^\d+$/, 'პირადი ნომერი უნდა შეიცავდეს მხოლოდ ციფრებს!')
                        .length(11, 'პირადი ნომერი უნდა შეიცავდეს 11 სიმბოლოს!'),


                    lastName: Yup.string()
                        .required('სავალდებულო')
                        .matches(/^[ა-ჰ]+$/, 'გვარი უნდა შეიცავდეს მხოლოდ ქართულ ასოებს!'),

                }),
                ...(isPhysicalExplanation && {
                    personalNumberExplanation: Yup.string()
                        .required('სავალდებულო')
                        .matches(/^\d+$/, 'პირადი ნომერი უნდა შეიცავდეს მხოლოდ ციფრებს!')
                        .length(11, 'პირადი ნომერი უნდა შეიცავდეს 11 სიმბოლოს!'),

                    lastNameExplanation: Yup.string()
                        .required('სავალდებულო')
                        .matches(/^[ა-ჰ]+$/, 'გვარი უნდა შეიცავდეს მხოლოდ ქართულ ასოებს!'),
                }),

                ...(isAssociation && {
                    legalAddress: Yup.string().required('სავალდებულო'),
                    clientName: Yup.string().required('სავალდებულო'),
                }),

                ...(isAssociationExplanation && {
                    legalAddressExplanation: Yup.string().required('სავალდებულო'),
                    clientNameExplanation: Yup.string().required('სავალდებულო'),
                }),

                ...(isForeigner && {
                    country: Yup.string().required('სავალდებულო'),
                    passportNumber: Yup.string().required('სავალდებულო'),
                    foreignerName: Yup.string().required('სავალდებულო'),
                    foreignerAddress: Yup.string().required('სავალდებულო'),
                }),
                ...(isForeignerExplanation && {
                    countryExplanation: Yup.string().required('სავალდებულო'),
                    passportNumberExplanation: Yup.string().required('სავალდებულო'),
                    foreignerNameExplanation: Yup.string().required('სავალდებულო'),
                    foreignerAddressExplanation: Yup.string().required('სავალდებულო'),
                }),

                ...(caseData && caseData.orderDepartment === nomenclatureEnum.building ? {
                    councilId: Yup.array()
                        .of(Yup.number())
                        .min(1, 'სავალდებულო')
                        .required('სავალდებულო'),
                } : {}),


                ...(caseData && caseData.orderDepartment === nomenclatureEnum.building ? {
                    populatedAreaId: Yup.array()
                        .of(Yup.number())
                        .min(1, 'სავალდებულო')
                        .required('სავალდებულო'),
                } : {}),

                ...(caseData && caseData.orderDepartment === nomenclatureEnum.explosion ? {
                    request: Yup.string().required('სავალდებულო'),
                } : {}),


                ...inputTypes.reduce((acc, inputType) => {
                    let validationRule = Yup.string();

                    if (inputType.integration === 1 && inputType.required && inputType.title === "საიდენტიფიკაციო ნომერი" && boomBoomOwnerValidationEnabled) {
                        validationRule = Yup.string()
                            .test('len', 'უნდა იყოს 9 ნიშნა ან 11 ნიშნა!', (val) => val && (val.length === 9 || val.length === 11))
                            .required('სავალდებულო');
                    }
                    if (inputType.integration === 1 && inputType.required && inputType.title === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი" && objectOwnerValidationEnabled) {
                        validationRule = Yup.string()
                            .test('len', 'უნდა იყოს 9 ნიშნა ან 11 ნიშნა!', (val) => val && (val.length === 9 || val.length === 11))
                            .required('სავალდებულო');
                    }

                    if (inputType.integration === 1 && inputType.required && inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი" && exploitationCompanyValidationEnabled) {
                        validationRule = Yup.string()
                            .test('len', 'უნდა იყოს 9 ნიშნა ან 11 ნიშნა!', (val) => val && (val.length === 9 || val.length === 11))
                            .required('სავალდებულო');
                    }

                    if (inputType.type === 5) {
                        validationRule = Yup.date();
                    } else if (inputType.type === 6) {
                        validationRule = Yup.string().matches(/^\+?\d[\d-]*\d$/, 'შეიყვანეთ ვალიდური ტელეფონის ნომერი');
                    } else if (inputType.type === 7) {
                        validationRule = Yup.string().email('შეიყვანეთ ვალიდური ელ-ფოსტა');
                    }

                    if (inputType.required && inputType.integration !== 1) {
                        validationRule = validationRule.required('სავალდებულო');
                    }

                    acc[inputType.title] = validationRule;
                    return acc;
                }, {}),
                permitTypePriceId: isAccelerationChecked ? Yup.number().required('სავალდებულო') : Yup.number().nullable()

            }
        ));
    }, [isAccelerationChecked, inputTypes, boomBoomOwnerValidationEnabled, objectOwnerValidationEnabled, exploitationCompanyValidationEnabled]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const permitTypeId = urlParams.get('parentId');
                const caseId = permitTypeId;
                const permitTypeResponse = await axios.get(`${baseURL}/GetPermitTypeByID?Id=${permitTypeId}`);
                if (permitTypeResponse.data.success) {
                    setParentCaseData(permitTypeResponse.data.data);

                }
                const regionsResponse = await axios.get(`${baseURL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                if (regionsResponse.data.success) {
                    setRegions(regionsResponse.data.data.resultlist);
                }
                const inputTypesResponse = await axios.get(`${baseURL}/GetInputTypesByCaseID?CaseId=${caseId}`);
                if (inputTypesResponse.data.success) {
                    let fetchedInputTypes = inputTypesResponse.data.data.list.filter(inputType => !inputType.internal);

                    fetchedInputTypes = fetchedInputTypes.map(inputType => ({
                        ...inputType,
                        valueId: inputType.value,
                        value: undefined
                    }));
                    fetchedInputTypes.sort((a, b) => a.sort - b.sort);

                    const restrictedTitlesForLegal = [
                        "საიდენტიფიკაციო ნომერი",
                        "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია",
                        "ორგანიზაციის იურიდიული მისამართი",
                        "ობიექტის მფლობელის საიდენტიფიკაციო კოდი",
                        "ობიექტის მფლობელის დასახელება",
                        "ობიექტის მფლობელის იურიდიული მისამართი",
                    ]

                    if (!isLegal) {
                        fetchedInputTypes = fetchedInputTypes.filter(
                            inputType => !restrictedTitlesForLegal.includes(inputType.title)
                        );
                    }

                    const restrictedTitlesForLegalExplanation = [
                        "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი",
                        "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება",
                        "ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი",
                    ]

                    if (!isLegalExplanation) {
                        fetchedInputTypes = fetchedInputTypes.filter(
                            inputType => !restrictedTitlesForLegalExplanation.includes(inputType.title)
                        );
                    }

                    const restrictedTitlesForObjectRegistrationIfUserIsSelfCustomer = [
                        "ობიექტის მფლობელის საკონტაქტო ელ-ფოსტა",
                    ]

                    if (isSelfCustomer) {
                        fetchedInputTypes = fetchedInputTypes.filter(
                            inputType => !restrictedTitlesForObjectRegistrationIfUserIsSelfCustomer.includes(inputType.title)
                        );
                    }

                    const restrictedTitlesForObjectRegistrationIfUserIsSelfCustomerExplanation = [
                        "ობიექტის ექსპლუატაციის გამწევის საკონტაქტო ელ-ფოსტა",
                        "ობიექტის ექსპლუატაციის გამწევი პირის ფაქტრიური მისამართი",
                        "ობიექტის ექსპლუატაციის გამწევი პირის საკონტაქტო ტელეფონი",
                    ]

                    if (isSelfCustomerExplanation) {
                        fetchedInputTypes = fetchedInputTypes.filter(
                            inputType => !restrictedTitlesForObjectRegistrationIfUserIsSelfCustomerExplanation.includes(inputType.title)
                        );
                    }

                    setInputTypes(fetchedInputTypes);

                    const dynamicInitialValues = fetchedInputTypes.reduce((acc, inputType) => {
                        acc[inputType.title] = "";
                        return acc;
                    }, {});

                    setInitialValues(prevValues => ({
                        ...prevValues,
                        ...dynamicInitialValues
                    }));
                    setGenerateFormik(true)
                }
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    useEffect(() => {
        const fetchFileTypes = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`);
                const fileTypes = response.data.data;

                const urlParams = new URLSearchParams(location.search);
                const permitTypeId = parseInt(urlParams.get('id'), 10);

                const shouldShowCheckbox = fileTypes.some(fileType => fileType.isCheck && fileType.caseId === permitTypeId);

                setShowAccelerationCheckbox(shouldShowCheckbox);
            } catch (error) {
            }
        };

        void fetchFileTypes();
    }, [location.search]);


    const handleRegionChange = async (selectedRegionIds) => {
        try {
            const dictionaryrequests = selectedRegionIds.map(regionId => ({
                dictionaryTypeId: geoIds.municipalityId,
                dictionaryId: regionId
            }));

            const response = await axios.post(`${baseURL}/GetAllDictionaryByDictionaryId`, {items: dictionaryrequests});

            if (response.data.success) {
                setMunicipalities(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleMunicipalityChange = async (selectedMunicipalityIds) => {
        try {
            const dictionaryrequests = selectedMunicipalityIds.map(municipalityId => ({
                dictionaryTypeId: geoIds.councilId,
                dictionaryId: municipalityId
            }));

            const response = await axios.post(`${baseURL}/GetAllDictionaryByDictionaryId`, {items: dictionaryrequests});

            if (response.data.success) {
                setCouncils(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleCouncilChange = async (selectedCouncilIds) => {
        try {
            const dictionaryrequests = selectedCouncilIds.map(councilId => ({
                dictionaryTypeId: geoIds.cityId,
                dictionaryId: councilId
            }));
            const response = await axios.post(`${baseURL}/GetAllDictionaryByDictionaryId`, {items: dictionaryrequests});
            if (response.data.success) {
                setPopulatedAreas(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };


    const openConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };
    const closeConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };
    const [formInteracted, setFormInteracted] = useState(false);


    const handleInteraction = () => {
        if (!formInteracted) setFormInteracted(true);
    };

    const handleSubmit = (values, {validateForm}) => {
        if (userRole !== "USER") {
            const serializedValues = {
                ...values,
                regionId: values.regionId?.length > 0 ? formatGeoData(values.regionId) : "",
                municipalityId: values.municipalityId?.length > 0 ? formatGeoData(values.municipalityId) : "",
                councilId: values.councilId?.length > 0 ? formatGeoData(values.councilId) : "",
                populatedAreaId: values.populatedAreaId?.length > 0 ? formatGeoData(values.populatedAreaId) : "",
                oldCaseNumber: creteByExpertCaseNumber ? values.oldCaseNumber || null : null
            };
            setFormDataToSubmit(serializedValues);
            openConfirmationModal();
            return
        }

        validateForm().then(errors => {
            if (Object.keys(errors).length === 0) {
                const serializedValues = {
                    ...values,
                    regionId: values.regionId?.length > 0 ? formatGeoData(values.regionId) : "",
                    municipalityId: values.municipalityId?.length > 0 ? formatGeoData(values.municipalityId) : "",
                    councilId: values.councilId?.length > 0 ? formatGeoData(values.councilId) : "",
                    populatedAreaId: values.populatedAreaId?.length > 0 ? formatGeoData(values.populatedAreaId) : "",
                };
                setFormDataToSubmit(serializedValues);
                openConfirmationModal();
            }
        });
    };

    const handleFormSubmit = async () => {
        try {

            const formattedData = {...formDataToSubmit};
            inputTypes.forEach(inputType => {
                const value = formattedData[inputType.title];

                if (inputType.integration === 1 || (inputType.type === 3 && !value)) {
                    delete formattedData[inputType.title];
                } else if (inputType.type === 5 && value) {
                    formattedData[inputType.title] = format(new Date(value), 'dd/MM/yyyy');
                }
            });

            const payload = {
                settingEndpointKeyWord: 'AddNewCase',
                ipAddress: '124124',
                permitTypeId: parseInt(getPermitTypeIdFromURL(), 10),
                regionId: formattedData.regionId,
                cityId: formattedData.municipalityId,
                councilId: formattedData.councilId,
                populatedAreaId: formattedData.populatedAreaId,
                objectName: "",
                cadastralCode: cadastralCodeArray.length > 0 ? cadastralCodeArray.join('$') : "",  // Check if array is empty
                address: formattedData.address,
                requestedSpeedUp: isAccelerationChecked,
                finished: true,
                acceleration: isAccelerationChecked,
                permitTypePriceId: isAccelerationChecked ? selectedPermitTypePriceId : null,
                councilRejected: LocationProps.notDeclined,
                populatedAreaRejected: LocationProps.notDeclined,
                regionRejected: LocationProps.notDeclined,
                cityRejected: LocationProps.notDeclined,
                hasBuilidngDocument: hasBuilidngDocument,
                creteByExpertCaseNumber: creteByExpertCaseNumber,
                createObjectRegistryID: creteByExpertCaseNumber,
                creteByExpert: userRole !== "ROOTADMIN" && userRole !== "USER",
                oldCaseNumber: formattedData.oldCaseNumber ? formattedData.oldCaseNumber : null,
                caseParentId: parseInt(formattedData.parentId, 10) || null,
                request:
                    caseData.orderDepartment === nomenclatureEnum.building ? parentCaseData.title :
                        caseData.orderDepartment === nomenclatureEnum.registery ? "ობიექტის რეგისტრაცია: " + caseData.title :
                            caseData.orderDepartment === nomenclatureEnum.explosion && formattedData.request ? formattedData.request :
                                null
            };

            const addNewCaseResponse = await axios.post(`${baseURL}/AddNewCase`, payload);

            if (!addNewCaseResponse.data.success) {
                setAlert({message: addNewCaseResponse.data.errorMessage, severity: 'error'});
                setShowAlert(true);
                return
            }


            if (addNewCaseResponse.data.success && addNewCaseResponse.data.resultId !== undefined) {
                const resultId = addNewCaseResponse.data.resultId;
                const caseDetails = inputTypes
                    .filter(inputType => formattedData.hasOwnProperty(inputType.title))
                    .map(inputType => ({
                        caseDetailInfo: {
                            caseId: parseInt(resultId, 10),
                            key: inputType.title,
                            value: formattedData[inputType.title] || "",
                            inputType: inputType.type === 1 ? 1 : 0,
                            dictionaryTypeId: inputType.valueId || null,
                            dictionaryId: dropdownOptions[inputType.title]?.find(option => option.label === formattedData[inputType.title])?.value || null,
                            hasDeadline: false,
                            hasFile: false,
                            unicId: inputType.unicId,
                            visibleOnTable: inputType.visibleOnTable,
                            visibleOnTableForUser: inputType.visibleOnTableForUser,
                            isIdentificationNumber: inputType.integration === 1
                        }
                    }));


                const additionalCaseDetails = {
                    personalNumber: formattedData.personalNumber,
                    personalNumberExplanation: formattedData.personalNumberExplanation,
                    firstName: userFirstName,
                    firstNameExplanation: userFirstNameExp,
                    lastName: formattedData.lastName,
                    lastNameExplanation: formattedData.lastNameExplanation,
                    clientName: formattedData.clientName,
                    clientNameExplanation: formattedData.clientNameExplanation,
                    legalAddress: formattedData.legalAddress,
                    legalAddressExplanation: formattedData.legalAddressExplanation,
                    identificationNumberForAssociation: formattedData.identificationNumberForAssociation,
                    identificationNumberForAssociationExplanation: formattedData.identificationNumberForAssociationExplanation,
                    country: formattedData.country,
                    countryExplanation: formattedData.countryExplanation,
                    passportNumber: formattedData.passportNumber,
                    passportNumberExplanation: formattedData.passportNumberExplanation,
                    foreignerName: formattedData.foreignerName,
                    foreignerNameExplanation: formattedData.foreignerNameExplanation,
                    foreignerAddress: formattedData.foreignerAddress,
                    foreignerAddressExplanation: formattedData.foreignerAddressExplanation,

                };

                const valuesInGeorgian = {
                    personalNumber: "დამკვეთის პირადი ნომერი",
                    personalNumberExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი",
                    firstName: "დამკვეთის სახელი",
                    firstNameExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის სახელი",
                    lastName: "დამკვეთის გვარი",
                    lastNameExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის გვარი",
                    clientName: "დამკვეთის სახელი",
                    clientNameExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის სახელი",
                    legalAddress: "დამკვეთის იურიდიული მისამართი",
                    legalAddressExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი",
                    identificationNumberForAssociationExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი",
                    identificationNumberForAssociation: "დამკვეთის საიდენთიფიკაციო ნომერი",
                    country: "ქვეყანა",
                    countryExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის ქვეყანა",
                    passportNumber: "პასპორტის ნომერი",
                    passportNumberExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი",
                    foreignerName: "დამკვეთის სახელი",
                    foreignerNameExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის სახელი",
                    foreignerAddress: "მისამართი",
                    foreignerAddressExplanation: "ობიექტის ექსპლუატაციის გამწევი პირის მისამართი",
                    pNumber: "პირადი ნომერი",
                    organizationName: "ორგანიზაციის სახელი",
                    organizationNameExplanation: "ორგანიზაციის სახელი",
                    orgName: "ორგანიზაციის სახელი",
                    orgNumber: "ორგანიზაციის ნომერი",
                    email: "ობიექტის მფლობელის საკონტაქტო ელ-ფოსტა",

                }

                const valuesInGeorgianExplanation = {
                    firstName: "ობიექტის ექსპლუატაციის გამწევი პირის სახელი",
                    lastName: "ობიექტის ექსპლუატაციის გამწევი პირის გვარი",
                    pNumber: "ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი",
                    orgName: "ობიექტის ექსპლუატაციის გამწევი პირის ორგანიზაციის სახელი",
                    orgNumber: "ობიექტის ექსპლუატაციის გამწევი პირის ორგანიზაციის ნომერი",
                    email: "ობიექტის ექსპლუატაციის გამწევი პირის ელ-ფოსტა",
                }

                const personalDetails = Object.entries(additionalCaseDetails)
                    .filter(([_, value]) => value != null && value !== "")
                    .map(([key, value]) => ({
                        caseDetailInfo: {
                            caseId: parseInt(resultId, 10),
                            key: valuesInGeorgian[key],
                            value: value,
                            inputType: 3,
                            dictionaryTypeId: null,
                            dictionaryId: null,
                            hasDeadline: false,
                            hasFile: false,
                            unicId: false,
                            visibleOnTable: false,
                            visibleOnTableForUser: false,
                            isIdentificationNumber: false
                        }
                    }));

                const autoSubmittedData = Object.entries(userData)
                    .filter(([_, value]) => value != null && value !== "")
                    .map(([key, value]) => ({
                        caseDetailInfo: {
                            caseId: parseInt(resultId, 10),
                            key: valuesInGeorgian[key],
                            value: value,
                            inputType: 3,
                            dictionaryTypeId: null,
                            dictionaryId: null,
                            hasDeadline: false,
                            hasFile: false,
                            unicId: false,
                            visibleOnTable: false,
                            visibleOnTableForUser: false,
                            isIdentificationNumber: false
                        }
                    }));

                const autoSubmittedDataExplanation = Object.entries(userData)
                    .filter(([_, value]) => value != null && value !== "")
                    .map(([key, value]) => ({
                        caseDetailInfo: {
                            caseId: parseInt(resultId, 10),
                            key: valuesInGeorgianExplanation[key],
                            value: value,
                            inputType: 3,
                            dictionaryTypeId: null,
                            dictionaryId: null,
                            hasDeadline: false,
                            hasFile: false,
                            unicId: false,
                            visibleOnTable: false,
                            visibleOnTableForUser: false,
                            isIdentificationNumber: false
                        }
                    }));
                const isRegistery = caseData.orderDepartment === nomenclatureEnum.registery
                const isPhysicalAndHasFullName = isPhysical && userFirstName && lastName && isRegistery
                const isPhysicalExpAndHasFullName = isPhysicalExplanation && userFirstNameExp && lastNameExp && isRegistery
                const isForeignerAndHasName = isForeigner && formattedData.foreignerName && isRegistery
                const isForeignerAndHasNameExp = isForeignerExplanation && formattedData.foreignerNameExplanation && isRegistery
                const isAssociationAndHasClientName = isAssociation && formattedData.clientName && isRegistery
                const isAssociationAndHasClientNameExp = isAssociationExplanation && formattedData.clientNameExplanation && isRegistery

                let extendedCaseDetails = [
                    ...caseDetails,
                    ...generateAdditionalCaseDetails(companyInfo, resultId, "companyInfo"),
                    ...generateAdditionalCaseDetails(objectOwnerInfo, resultId, "objectOwnerInfo"),
                    ...generateAdditionalCaseDetails(boomBoomOwnerInfo, resultId, "boomBoomOwnerInfo"),
                    ...generateAdditionalCaseDetails(exploitationCompanyInfo, resultId, "exploitationCompanyInfo"),
                    ...personalDetails,
                    ...(isSelfCustomer ? autoSubmittedData : []),
                    ...(isPhysicalAndHasFullName ? generateObjectOwner(resultId, `${userFirstName} ${lastName}`) : []),
                    ...(isPhysicalExpAndHasFullName ? generateObjectOwnerExp(resultId, `${userFirstNameExp} ${lastNameExp}`) : []),
                    ...(isForeignerAndHasName ? generateObjectOwner(resultId, formattedData.foreignerName) : []),
                    ...(isForeignerAndHasNameExp ? generateObjectOwnerExp(resultId, formattedData.foreignerNameExplanation) : []),
                    ...(isAssociationAndHasClientName ? generateObjectOwner(resultId, formattedData.clientName) : []),
                    ...(isAssociationAndHasClientNameExp ? generateObjectOwnerExp(resultId, formattedData.clientNameExplanation) : []),
                    ...(isSelfCustomer ? generateObjectOwner(resultId, `${userData.firstName} ${userData.lastName}`) : []),
                ];


                const addCaseDetailsResponse = await axios.post(`${baseURL}/AddCaseDetails`, {caseDetails: extendedCaseDetails});
                const urlParams = new URLSearchParams(window.location.search);
                const caseIdFromUrlForInputTypes = urlParams.get('parentId');

                const chatPayload = {
                    caseID: parseInt(resultId, 10)
                }

                await axios.post(`${baseURL}/AddChatGroupForNewCase`, chatPayload)

                if (addCaseDetailsResponse.data.success) {


                    await autoSubmitInternalInputs(resultId)
                    closeConfirmationModal();
                    if (userRole !== "USER") {
                        navigate(`/dashboard/newcase/uploadfilesexpert?id=${getPermitTypeIdFromURL()}&caseid=${resultId}&municipalityId=${parseInt(formattedData.municipalityId, 10)}&parentId=${caseIdFromUrlForInputTypes}`)
                    } else {
                        navigate(`/dashboard/newcase/uploadfiles?id=${getPermitTypeIdFromURL()}&caseid=${resultId}&municipalityId=${(formattedData.municipalityId)}&parentId=${caseIdFromUrlForInputTypes}&entity=${entity}&explanationEntity=${explanationEntity}`);
                    }


                }
            }
        } catch (error) {
        }
    };


    const customStyles = {
        control: (provided) => ({
            ...provided,
            width: window.innerWidth < 768 ? '90%' : '426px',
            cursor: "pointer",
            minHeight: '60px',
            backgroundColor: '#f4f6fa',
            borderRadius: '15px',
            border: 'none',
            color: '#93a6cc',
            fontSize: '18px',
            fontFamily: 'FiraGO-Regular, serif',
            paddingLeft: '20px',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
            transition: 'color 0.3s ease, background-color 0.3s ease',
        }),
        option: (provided) => ({
            ...provided,
            color: '#93a6cc',
            cursor: "pointer",
            fontFamily: 'FiraGO-Regular, serif',
            paddingLeft: '20px',
        }),
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: '#93a6cc',
            }
        }
    };

    const renderError = (message) => <p className="help is-danger">{message}</p>;

    const handleDeleteCadastralCode = (codeToDelete) => {
        setCadastralCodeArray((prevArray) => prevArray.filter(code => code !== codeToDelete));
    };

    return (
        <div className={"apl-container"}>
            <InfoPopup open={dialogOpen} onClose={handleCloseDialog} title={infoTitle} info={info}/>
            {!generateFormik || !caseData || !parentCaseData ? (
                <LoaderCustom/>
            ) : (Object.keys(initialValues).length > 0 && (
                <div className={"apl-component"}>
                    <h1 className="apl-title">{title}</h1>
                    <ExcelPopup isVisible={isCompanyDataLoading} loaderText={"მონაცემები მუშავდება"}
                                loaderType={"CompanyInfo"}/>
                    <ExcelPopup isVisible={isUserDataIsLoading} loaderText={"მონაცემები მუშავდება"}
                                loaderType={"CompanyInfo"}/>
                    <ExcelPopup isVisible={isCadastralCodeLoading}
                                loaderText={"მიმდინარეობს საკადასტრო კოდის ვერიფიკაცია"}
                                loaderType={"CadastralCode"}/>

                    <Snackbar
                        open={showAlert}
                        autoHideDuration={6000}
                        onClose={() => {
                            setShowAlert(false);

                        }}
                        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    >
                        <Alert onClose={() => {
                            setShowAlert(false);

                        }} severity={alert.severity} sx={{width: '100%'}}>
                            {alert.message}
                        </Alert>
                    </Snackbar>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={userRole !== 'USER' ? null : validationSchema}
                        onSubmit={handleSubmit}
                        validateOnBlur={true}
                        validateOnChange={true}
                    >
                        {({isValid, dirty}) => (
                            <Form onChange={handleInteraction}>
                                <div className="field">
                                    <div style={{display: "flex", gap: 5}}>
                                        <label className="label-font" htmlFor="regionId">რეგიონი</label>
                                        <div title={"სავალდებულო"}>
                                            <FaAsterisk className="required-icon"/>
                                        </div>
                                        <div title={"აირჩიეთ ქვეყნის რეგიონი"}>
                                            <FaInfoCircle
                                                onClick={() => handleOpenDialog('აირჩიეთ ქვეყნის რეგიონი', 'რეგიონი')}
                                                className={"input-info-icon"}/>
                                        </div>
                                    </div>
                                    <div className="control">
                                        <Field name="regionId">
                                            {({field, form}) => (
                                                <Select
                                                    options={regionOptions}
                                                    name="regionId"
                                                    isMulti={true}
                                                    value={regionOptions.filter(option => field.value.includes(option.value))}
                                                    onChange={options => {
                                                        const values = options ? options.map(option => option.value) : [];
                                                        form.setFieldValue("regionId", values);
                                                        void handleRegionChange(values);
                                                    }}
                                                    placeholder="აირჩიეთ რეგიონი"
                                                    styles={customStyles}
                                                    isSearchable
                                                    noOptionsMessage={() => "არაფერი მოიძებნა"}
                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="regionId" render={renderError}/>
                                    </div>
                                </div>
                                <div className="field">
                                    <div style={{display: "flex", gap: 5}}>
                                        <label className="label-font"
                                               htmlFor="municipalityId">მუნიციპალიტეტი</label>
                                        <div title={"სავალდებულო"}>
                                            <FaAsterisk className="required-icon"/>
                                        </div>
                                        <div title={"აირჩიეთ მუნიციპალიტეტი"}>
                                            <FaInfoCircle
                                                onClick={() => handleOpenDialog('აირჩიეთ მუნიციპალიტეტი', 'მუნიციპალიტეტი')}
                                                className={"input-info-icon"}/>
                                        </div>
                                    </div>
                                    <div className="control">
                                        <Field name="municipalityId">
                                            {({field, form}) => (
                                                <Select
                                                    options={municipalitiesOptions}
                                                    isMulti={true}
                                                    name="municipalityId"
                                                    value={municipalitiesOptions.filter(option => field.value.includes(option.value))}
                                                    onChange={options => {
                                                        const values = options ? options.map(option => option.value) : [];
                                                        form.setFieldValue("municipalityId", values);
                                                        void handleMunicipalityChange(values);
                                                    }}
                                                    placeholder="აირჩიეთ მუნიციპალიტეტი"
                                                    styles={customStyles}
                                                    isSearchable
                                                    noOptionsMessage={() => "ჯერ აირჩიეთ რეგიონი"}
                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="municipalityId" render={renderError}/>
                                    </div>
                                </div>


                                {caseData && caseData.orderDepartment === nomenclatureEnum.building && (
                                    <>
                                        <div className="field">
                                            <div style={{display: "flex", gap: 5}}>
                                                <label className="label-font" htmlFor="councilId">საკრებულო</label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div title={"აირჩიეთ საკრებულო"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('აირჩიეთ საკრებულო', 'საკრებულო')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field name="councilId">
                                                    {({field, form}) => (
                                                        <Select
                                                            options={councilsOptions}
                                                            isMulti={true}
                                                            name="councilId"
                                                            value={councilsOptions.filter(option => field.value.includes(option.value))}
                                                            onChange={options => {
                                                                const values = options ? options.map(option => option.value) : [];
                                                                form.setFieldValue("councilId", values);
                                                                void handleCouncilChange(values);
                                                            }}
                                                            placeholder="აირჩიეთ საკრებულო"
                                                            styles={customStyles}
                                                            isSearchable
                                                            noOptionsMessage={() => "ჯერ აირჩიეთ მუნიციპალიტეტი"}
                                                        />
                                                    )}
                                                </Field>

                                                <ErrorMessage name="councilId" render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <div style={{display: "flex", gap: 5}}>
                                                <label className="label-font" htmlFor="populatedAreaId">დასახლებული
                                                    პუნქტი</label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div title={"აირჩიეთ დასახლებული პუნქტი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('აირჩიეთ დასახლებული პუნქტი', 'დასახლებული პუნქტი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field name="populatedAreaId">
                                                    {({field, form}) => (
                                                        <Select
                                                            options={populatedAreasOptions}
                                                            isMulti={true}
                                                            name="populatedAreaId"
                                                            value={populatedAreasOptions.filter(option => field.value.includes(option.value))}
                                                            onChange={options => {
                                                                const values = options ? options.map(option => option.value) : [];
                                                                form.setFieldValue("populatedAreaId", values);
                                                            }}
                                                            placeholder="აირჩიეთ დასახლებული პუნქტი"
                                                            styles={customStyles}
                                                            isSearchable
                                                            noOptionsMessage={() => "ჯერ აირჩიეთ საკრებულო"}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name="populatedAreaId" render={renderError}/>
                                            </div>


                                        </div>
                                    </>
                                )}
                                <div className="field" key={"address"}>
                                    <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                        <label className="label-font" htmlFor={"address"}>ობიექტის მისამართი
                                        </label>
                                        <div title={"სავალდებულო"}>
                                            <FaAsterisk className="required-icon"/>
                                        </div>
                                        <div
                                            title={"ობიექტის მისამართი"}>
                                            <FaInfoCircle
                                                onClick={() => handleOpenDialog('მიუთითეთ ობიექტის შეძლებისდაგვარად ზუსტი მისამართი, ხოლო მისი არარსებობის შემთხვევაში ახლომდებარე დამისამართებული კონკრეტული ადგილი/ საქმიანობის სახეობა', 'ობიექტის მისამართი')}
                                                className={"input-info-icon"}/>
                                        </div>
                                    </div>
                                    <div className="control">
                                        <Field
                                            name={"address"}
                                            type="text"
                                            as="textarea"
                                            className="custom-input-oldTextArea"
                                            placeholder={"ობიექტის მისამართი"}
                                            maxLength="700"
                                        />
                                        <ErrorMessage name={"address"} render={renderError}/>
                                    </div>
                                </div>
                                {caseData &&
                                    ((caseData.orderDepartment === nomenclatureEnum.building)
                                        || (caseData.orderDepartment === nomenclatureEnum.registery && !caseHasExploitationField)) &&
                                    (
                                        <>
                                            <div className="field">
                                                <div style={{
                                                    display: "flex",
                                                    gap: 5,
                                                    marginTop: 15
                                                }}>
                                                    <label className="label-font"
                                                           htmlFor="municipalityId">საკადასტრო კოდი</label>
                                                    <div
                                                        title={"არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი"}>
                                                        <FaInfoCircle
                                                            onClick={() => handleOpenDialog('არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი', 'საკადასტრო კოდი')}
                                                            className={"input-info-icon"}/>
                                                    </div>
                                                </div>
                                                <div className="control input-wrapper has-icons-right">
                                                    <Field
                                                        type="text"
                                                        className="custom-input-cadastral"
                                                        placeholder="საკადასტრო კოდი"
                                                        maxLength="700"
                                                        name="cadastralCode"
                                                    >
                                                        {({field, form}) => (
                                                            <div className="control has-icons-right">
                                                                <input
                                                                    className="custom-input-cadastral"
                                                                    style={{
                                                                        border: alert.message === "საკადასტრო კოდი არასწორია" ? '1px solid red' :
                                                                            alert.message === "საკადასტრო კოდი უკვე დამატებულია სიაში!" ? '1px solid yellow'
                                                                                : "none"
                                                                    }}
                                                                    value={cadastralCode}
                                                                    placeholder={"საკადასტრო კოდი"}
                                                                    onChange={(e) => setCadastralCode(e.target.value)}
                                                                />
                                                                <div>
                                                                    <div>
                                                                        <Tooltip
                                                                            title={cadastralCode === "" ? "გთხოვთ შეიყვანოთ საკადასტრო კოდი" : "საკადასტრო კოდის დამატება"}
                                                                        >
                                                                            <div
                                                                                className="uniqueId-icon-wrapper-build">
                                                                                <FaPlus
                                                                                    className={"input-search-button" + (cadastralCode === "" ? " disabled" : "")}
                                                                                    onClick={() => fetchCadastralCode(cadastralCode)}
                                                                                    style={{
                                                                                        cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                                                                        color: cadastralCode === "" ? "#ccc" : "#0e5bd0"
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Field>
                                                </div>
                                            </div>


                                            {cadastralCodeArray.length > 0 && (
                                                <>
                                                    <label className="label-font">არჩეული საკადასტრო კოდები:</label>
                                                    <div className="casecreate-chips-container">
                                                        {cadastralCodeArray.map((code, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={code}
                                                                onDelete={() => handleDeleteCadastralCode(code)}
                                                                deleteIcon={<MdClose/>}
                                                                className="casecreate-chips-chip"
                                                            />
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )
                                }

                                {caseData && caseData.orderDepartment === nomenclatureEnum.explosion && (
                                    <>
                                        <div className="field">
                                            <div style={{
                                                display: "flex",
                                                gap: 5,
                                                marginTop: 15
                                            }}>
                                                <label className="label-font"
                                                       htmlFor="municipalityId">საკადასტრო კოდი</label>
                                                <div
                                                    title={"არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი', 'საკადასტრო კოდი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control input-wrapper has-icons-right">
                                                <Field
                                                    type="text"
                                                    className="custom-input-cadastral"
                                                    placeholder="საკადასტრო კოდი"
                                                    maxLength="700"
                                                    name="cadastralCode"
                                                >
                                                    {({field, form}) => (
                                                        <div className="control has-icons-right">
                                                            <input
                                                                className="custom-input-cadastral"
                                                                style={{
                                                                    border: alert.message === "საკადასტრო კოდი არასწორია" ? '1px solid red' :
                                                                        alert.message === "საკადასტრო კოდი უკვე დამატებულია სიაში!" ? '1px solid yellow'
                                                                            : "none"
                                                                }}
                                                                value={cadastralCode}
                                                                placeholder={"საკადასტრო კოდი"}
                                                                onChange={(e) => setCadastralCode(e.target.value)}
                                                            />
                                                            <div>
                                                                <div>
                                                                    <Tooltip
                                                                        title={cadastralCode === "" ? "გთხოვთ შეიყვანოთ საკადასტრო კოდი" : "საკადასტრო კოდის დამატება"}
                                                                    >
                                                                        <div
                                                                            className="uniqueId-icon-wrapper-build">
                                                                            <FaPlus
                                                                                className={"input-search-button" + (cadastralCode === "" ? " disabled" : "")}
                                                                                onClick={() => fetchCadastralCode(cadastralCode)}
                                                                                style={{
                                                                                    cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                                                                    color: cadastralCode === "" ? "#ccc" : "#0e5bd0"
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Field>
                                            </div>
                                        </div>


                                        {cadastralCodeArray.length > 0 && (
                                            <>
                                                <label className="label-font">არჩეული საკადასტრო კოდები:</label>
                                                <div className="casecreate-chips-container">
                                                    {cadastralCodeArray.map((code, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={code}
                                                            onDelete={() => handleDeleteCadastralCode(code)}
                                                            deleteIcon={<MdClose/>}
                                                            className="casecreate-chips-chip"
                                                        />
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </>

                                )}
                                {caseData && caseData.hasParentId && (
                                    <div className="field" key={"parentId"}>
                                        <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                            <label className="label-font" htmlFor={"parentId"}>წინა
                                                განაცხადის
                                                ნომერი</label>
                                            <div title={"სავალდებულო"}>
                                                <FaAsterisk className="required-icon"/>
                                            </div>
                                            <div title={"შეიყვანეთ წინა განაცხადის ნომერი"}>
                                                <FaInfoCircle
                                                    onClick={() => handleOpenDialog('შეიყვანეთ წინა განაცხადის ნომერი', 'წინა განაცხადის ნომერი')}
                                                    className={"input-info-icon"}/>
                                            </div>
                                        </div>
                                        <div className="control">
                                            <Field
                                                name={"parentId"}
                                                type="text"
                                                className="custom-input"
                                                placeholder={"წინა განაცხადის ნომერი"}
                                                maxLength="700"
                                            />
                                            <ErrorMessage name={"parentId"} render={renderError}/>
                                        </div>
                                    </div>
                                )}


                                {isForeigner && (
                                    <>
                                        <div className="field" key={"passportNumber"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"passportNumber"}>პასპორტის
                                                    ნომერი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"პასპორტის ნომერი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ პასპორტის ნომერი', 'პასპორტის ნომერი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"passportNumber"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"პასპორტის ნომერი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"passportNumber"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"foreignerName"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"foreignerName"}>დამკვეთის სახელი</label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"დამკვეთის სახელი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ დამკვეთის სახელი', 'დამკვეთის სახელი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"foreignerName"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"დამკვეთის სახელი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"foreignerName"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"foreignerAddress"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"foreignerAddress"}>მისამართი</label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"მისამართი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ მისამართი', 'მისამართი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"foreignerAddress"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"მისამართი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"foreignerAddress"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{display: 'flex', gap: 5, marginBottom: 5}}>
                                                <label className="label-font" htmlFor="country">ქვეყანა</label>
                                                <div title="სავალდებულო">
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div title="აირჩიეთ ქვეყანა">
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('აირჩიეთ ქვეყანა', 'ქვეყანა')}
                                                        className="input-info-icon"
                                                    />
                                                </div>
                                            </div>
                                            <Field name="country">
                                                {({field, form}) => (
                                                    <Select
                                                        options={countryOptions}
                                                        name="country"
                                                        value={countryOptions.find(option => option.value === field.value)}
                                                        onChange={option => form.setFieldValue('country', option?.label || '')}
                                                        placeholder="ქვეყანა"
                                                        styles={customStyles}
                                                        isSearchable
                                                    />
                                                )}
                                            </Field>
                                            <ErrorMessage name="country" render={renderError}/>
                                        </div>
                                    </>
                                )}

                                {isForeignerExplanation && (
                                    <>
                                        <div className="field" key={"passportNumberExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"passportNumberExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი', 'ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"passportNumberExplanation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"ობიექტის ექსპლუატაციის გამწევი პირის პასპორტის ნომერი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"passportNumberExplanation"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"foreignerNameExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"foreignerNameExplanation"}>ობიექტის ექსპლუატაციის
                                                    გამწევი პირის სახელი</label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის სახელი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის სახელი', 'ობიექტის ექსპლუატაციის გამწევი პირის სახელი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"foreignerNameExplanation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"ობიექტის ექსპლუატაციის გამწევი პირის სახელი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"foreignerNameExplanation"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"foreignerAddressExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"foreignerAddressExplanation"}>ობიექტის ექსპლუატაციის
                                                    გამწევი პირის მისამართი</label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის მისამართი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის მისამართი', 'ობიექტის ექსპლუატაციის გამწევი პირის მისამართი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"foreignerAddressExplanation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"ობიექტის ექსპლუატაციის გამწევი პირის მისამართი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"foreignerAddressExplanation"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{display: 'flex', gap: 5, marginBottom: 5}}>
                                                <label className="label-font" htmlFor="countryExplanation">ობიექტის
                                                    ექსპლუატაციის გამწევი პირის ქვეყანა</label>
                                                <div title="სავალდებულო">
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div title="აირჩიეთ ობიექტის ექსპლუატაციის გამწევი პირის ქვეყანა">
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('აირჩიეთ ობიექტის ექსპლუატაციის გამწევი პირის ქვეყანა', 'ობიექტის ექსპლუატაციის გამწევი პირის ქვეყანა')}
                                                        className="input-info-icon"
                                                    />
                                                </div>
                                            </div>
                                            <Field name="countryExplanation">
                                                {({field, form}) => (
                                                    <Select
                                                        options={countryOptions}
                                                        name="country"
                                                        value={countryOptions.find(option => option.value === field.value)}
                                                        onChange={option => form.setFieldValue('countryExplanation', option?.label || '')}
                                                        placeholder="ობიექტის ექსპლუატაციის გამწევი პირის ქვეყანა"
                                                        styles={customStyles}
                                                        isSearchable
                                                    />
                                                )}
                                            </Field>
                                            <ErrorMessage name="country" render={renderError}/>
                                        </div>
                                    </>
                                )}


                                {isPhysical && (
                                    <>
                                        <div className="field" key={"personalNumber"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"personalNumber"}>პირადი ნომერი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"დამკვეთის პირადი ნომერი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ პირადი ნომერი', 'დამკვეთის პირადი ნომერი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field name="personalNumber">
                                                    {({field, form}) => (
                                                        <input
                                                            {...field}
                                                            value={personalNumber}
                                                            onChange={e => {
                                                                form.setFieldValue(field.name, e.target.value)
                                                                setPersonalNumber(e.target.value)
                                                            }}
                                                            type="text"
                                                            className="custom-input"
                                                            placeholder="დამკვეთის პირადი ნომერი"
                                                            maxLength={700}
                                                        />
                                                    )}
                                                </Field>

                                                <ErrorMessage name={"personalNumber"} render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"lastName"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"lastName"}>დამკვეთის გვარი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"გვარი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ დამკვეთის გვარი', 'დამკვეთის გვარი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field name="lastName">
                                                    {({field, form}) => (
                                                        <input
                                                            {...field}
                                                            value={lastName}
                                                            onChange={e => {
                                                                form.setFieldValue(field.name, e.target.value)
                                                                setLastName(e.target.value)
                                                            }}
                                                            type="text"
                                                            className="custom-input"
                                                            placeholder="დამკვეთის გვარი"
                                                            maxLength={700}
                                                        />
                                                    )}
                                                </Field>

                                                <ErrorMessage name={"lastName"} render={renderError}/>
                                            </div>
                                        </div>
                                        <div>
                                            <Tooltip
                                                title={(lastName === '' || personalNumber === '') ? "შეიყვანეთ დამკვეთის გვარი და დამკვეთის პირადი ნომერი!" : ""}>
                                            <span>
                                                <Button disabled={lastName === '' || personalNumber === ''}
                                                        endIcon={<FaSearch/>} variant="contained"
                                                        onClick={() => verifyPrivateNumber(personalNumber, lastName)}>ძიება</Button>
                                            </span>
                                            </Tooltip>
                                        </div>

                                        <div className="field" key={"firstName"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"firstName"}>დამკვეთის სახელი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"დამკვეთის სახელი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ დამკვეთის სახელი', 'დამკვეთის სახელი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>

                                            <div className="control">
                                                <Tooltip title={"შეავსეთ პირადი ნომერი და დამკვეთის გვარი"}>
                                                    <span>
                                                          <Field
                                                              name={"firstName"}
                                                              type="text"
                                                              className="custom-input-company"
                                                              placeholder={userFirstName ? userFirstName : 'დამკვეთის სახელი'}
                                                              maxLength="700"
                                                              disabled={true}
                                                          />
                                                    </span>
                                                </Tooltip>

                                                <ErrorMessage name={"firstName"} render={renderError}/>
                                            </div>
                                        </div>

                                    </>
                                )}

                                {isPhysicalExplanation && (
                                    <>
                                        <div className="field" key={"personalNumberExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"personalNumberExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი', 'ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field name="personalNumberExplanation">
                                                    {({field, form}) => (
                                                        <input
                                                            {...field}
                                                            value={personalNumberExp}
                                                            onChange={e => {
                                                                form.setFieldValue(field.name, e.target.value)
                                                                setPersonalNumberExp(e.target.value)
                                                            }}
                                                            type="text"
                                                            className="custom-input"
                                                            placeholder="ობიექტის ექსპლუატაციის გამწევი პირის პირადი ნომერი"
                                                            maxLength={700}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name={"personalNumberExplanation"} render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"lastNameExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"lastNameExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის გვარი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის გვარი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის გვარი', 'ობიექტის ექსპლუატაციის გამწევი პირის გვარი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field name="lastNameExplanation">
                                                    {({field, form}) => (
                                                        <input
                                                            {...field}
                                                            value={lastNameExp}
                                                            onChange={e => {
                                                                form.setFieldValue(field.name, e.target.value)
                                                                setLastNameExp(e.target.value)
                                                            }}
                                                            type="text"
                                                            className="custom-input"
                                                            placeholder="ობიექტის ექსპლუატაციის გამწევი პირის გვარი"
                                                            maxLength={700}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name={"lastNameExplanation"} render={renderError}/>
                                            </div>
                                        </div>
                                        <div>
                                            <Tooltip
                                                title={(lastNameExp === '' || personalNumberExp === '') ? "შეიყვანეთობიექტის ექსპლუატაციის გამწევი პირის გვარი და  პირადი ნომერი!" : ""}>
                                            <span>
                                                <Button disabled={lastNameExp === '' || personalNumberExp === ''}
                                                        endIcon={<FaSearch/>} variant="contained"
                                                        onClick={() => verifyPrivateNumber(personalNumberExp, lastNameExp, true)}>ძიება</Button>
                                            </span>
                                            </Tooltip>
                                        </div>
                                        <div className="field" key={"firstNameExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"firstNameExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის სახელი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის სახელი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის სახელი', 'ობიექტის ექსპლუატაციის გამწევი პირის სახელი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">

                                                <Field
                                                    name={"firstNameExplanation"}
                                                    type="text"
                                                    className="custom-input-company"
                                                    placeholder={userFirstNameExp ? userFirstNameExp : 'ობიექტის ექსპლუატაციის გამწევი პირის სახელი'}
                                                    maxLength="700"
                                                    disabled={true}
                                                />
                                                <ErrorMessage name={"firstNameExplanation"} render={renderError}/>
                                            </div>
                                        </div>

                                    </>
                                )}

                                {isAssociation && (
                                    <>
                                        <div className="field" key={"identificationNumberForAssociation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"identificationNumberForAssociation"}>დამკვეთის
                                                    საიდენთიფიკაციო
                                                    ნომერი
                                                </label>

                                                <div
                                                    title={"დამკვეთის საიდენთიფიკაციო ნომერი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ დამკვეთის საიდენთიფიკაციო ნომერი', 'დამკვეთის საიდენთიფიკაციო ნომერი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"identificationNumberForAssociation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"დამკვეთის საიდენთიფიკაციო ნომერი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"identificationNumberForAssociation"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"clientName"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"clientName"}>დამკვეთის სახელი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"დამკვეთის სახელი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ დამკვეთის სახელი', 'დამკვეთის სახელი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"clientName"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"დამკვეთის სახელი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"clientName"} render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"legalAddress"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"legalAddress"}>დამკვეთის
                                                    იურიდიული
                                                    მისამართი
                                                </label>
                                                <div title={"დამკვეთის იურიდიული მისამართი"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"დამკვეთის იურიდიული მისამართი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ იურიდიული მისამართი', 'დამკვეთის იურიდიული მისამართი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"legalAddress"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"დამკვეთის იურიდიული მისამართი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"legalAddress"} render={renderError}/>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {isAssociationExplanation && (
                                    <>
                                        <div className="field" key={"identificationNumberForAssociationExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font"
                                                       htmlFor={"identificationNumberForAssociationExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი
                                                </label>

                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი', 'ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"identificationNumberForAssociationExplanation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"ობიექტის ექსპლუატაციის გამწევი პირის საიდენთიფიკაციო ნომერი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"identificationNumberForAssociationExplanation"}
                                                              render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"clientNameExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"clientNameExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის სახელი
                                                </label>
                                                <div title={"სავალდებულო"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის სახელი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის სახელი', 'დამკვეთის ობიექტის ექსპლუატაციის გამწევი პირის სახელი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"clientNameExplanation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"ობიექტის ექსპლუატაციის გამწევი პირის სახელი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"clientNameExplanation"} render={renderError}/>
                                            </div>
                                        </div>
                                        <div className="field" key={"legalAddressExplanation"}>
                                            <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                                <label className="label-font" htmlFor={"legalAddressExplanation"}>
                                                    ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი
                                                </label>
                                                <div title={"იურიდიული მისამართი"}>
                                                    <FaAsterisk className="required-icon"/>
                                                </div>
                                                <div
                                                    title={"ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი"}>
                                                    <FaInfoCircle
                                                        onClick={() => handleOpenDialog('გთხოვთ მიუთითოთ ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი', 'ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი')}
                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={"legalAddressExplanation"}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={"ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი"}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={"legalAddressExplanation"} render={renderError}/>
                                            </div>
                                        </div>
                                    </>
                                )}


                                {caseData && caseData.orderDepartment === nomenclatureEnum.explosion && (
                                    <div className="field" key={"request"}>
                                        <div style={{display: "flex", gap: 5, marginTop: 20}}>
                                            <label className="label-font" htmlFor={"request"}>ფუნქციური დანიშნულება,
                                                ობიექტის აღწერილობა / საქმიანობის სახეობა</label>
                                            <div title={"სავალდებულო"}>
                                                <FaAsterisk className="required-icon"/>
                                            </div>
                                            <div
                                                title={"შეიყვანეთ სრული აღწერილობა ობიექტის დასახელების და საამფეთქებლო სამუშაოების მიზნის მითითებით"}>
                                                <FaInfoCircle
                                                    onClick={() => handleOpenDialog('შეიყვანეთ სრული აღწერილობა ობიექტის დასახელების და საამფეთქებლო სამუშაოების მიზნის მითითებით', 'ფუნქციური დანიშნულება, ობიექტის აღწერილობა / საქმიანობის სახეობა')}
                                                    className={"input-info-icon"}/>
                                            </div>
                                        </div>
                                        <div className="control">
                                            <Field
                                                name={"request"}
                                                type="text"
                                                as="textarea"
                                                className="custom-input-oldTextArea"
                                                placeholder={"ფუნქციური დანიშნულება, ობიექტის აღწერილობა / საქმიანობის სახეობა"}
                                                maxLength="700"
                                            />
                                            <ErrorMessage name={"request"} render={renderError}/>
                                        </div>
                                    </div>
                                )}


                                {inputTypes.map((inputType, index) => {
                                    if (inputType.type === 1) {
                                        return dropdownOptions[inputType.title] ? (

                                            <div className="field" key={"div" + inputType.id}>
                                                <div style={{display: "flex", gap: 10}}>
                                                    <label className="label-font" htmlFor={inputType.title}
                                                           id={`input${index + 1}`}>{inputType.title}</label>
                                                    {inputType.required && (
                                                        <div title={"სავალდებულო"}>
                                                            <FaAsterisk className="required-icon"/>
                                                        </div>
                                                    )}
                                                    {inputType.description && inputType.description !== "" && (
                                                        <div title={inputType.description}>
                                                            <FaInfoCircle
                                                                onClick={() => handleOpenDialog(inputType.description, inputType.title)}
                                                                className={"input-info-icon"}/>
                                                        </div>
                                                    )}

                                                </div>
                                                <div className="control">
                                                    <Field name={inputType.title}>
                                                        {({field, form}) => (
                                                            <Select
                                                                options={dropdownOptions[inputType.title]}
                                                                name={inputType.title}
                                                                value={dropdownOptions[inputType.title].find(option => option.value === field.value)}
                                                                onChange={option => {
                                                                    form.setFieldValue(inputType.title, option.label);
                                                                }}
                                                                placeholder={inputType.title}
                                                                styles={customStyles}
                                                                isSearchable
                                                            />
                                                        )}
                                                    </Field>
                                                    <ErrorMessage name={inputType.title} render={renderError}/>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>იტვირთება...</div>
                                        );
                                    } else if (inputType.type === 5) {
                                        return (
                                            <div className="field" key={"div" + inputType.id}>
                                                <div style={{display: "flex", gap: 10}}>
                                                    <label className="label-font" htmlFor={inputType.title}
                                                           id={`input${index + 1}`}>{inputType.title}</label>
                                                    {inputType.required && (
                                                        <div title={"სავალდებულო"}>
                                                            <FaAsterisk className="required-icon"/>
                                                        </div>
                                                    )}
                                                    {inputType.description && inputType.description !== "" && (
                                                        <div title={inputType.description}>
                                                            <FaInfoCircle
                                                                onClick={() => handleOpenDialog(inputType.description, inputType.title)}
                                                                className={"input-info-icon"}/>
                                                        </div>
                                                    )}

                                                </div>
                                                <div className="control">
                                                    <>
                                                        <Field name={inputType.title}>
                                                            {({form, field}) => (
                                                                <DatePicker
                                                                    {...field}
                                                                    selected={(field.value && new Date(field.value)) || null}
                                                                    onChange={val => form.setFieldValue(field.name, val)}
                                                                    locale={ka}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    className="custom-input"
                                                                    placeholderText={inputType.title}
                                                                    yearDropdownItemNumber={15}
                                                                    scrollableYearDropdown
                                                                    customInput={<input readOnly/>}
                                                                    icon={<FaCalendarAlt/>}
                                                                />
                                                            )}
                                                        </Field>
                                                    </>
                                                    <ErrorMessage name={inputType.title} render={renderError}/>
                                                </div>
                                            </div>
                                        );
                                    } else if (inputType.integration === 1) {
                                        return (
                                            <div className="field" key={"div" + inputType.id}>
                                                <div style={{display: "flex", gap: 10}}>
                                                    <label className="label-font" id={`input${index + 1}`}
                                                           htmlFor={inputType.title}>{inputType.title}</label>
                                                    {inputType.required && (
                                                        <div title={"სავალდებულო"}>
                                                            <FaAsterisk className="required-icon"/>
                                                        </div>
                                                    )}
                                                    {inputType.description && inputType.description !== "" && (
                                                        <div title={inputType.description}>
                                                            <FaInfoCircle
                                                                onClick={() => handleOpenDialog(inputType.description, inputType.title)}
                                                                className={"input-info-icon"}/>
                                                        </div>
                                                    )}

                                                </div>
                                                <div className="control input-wrapper has-icons-right">
                                                    <Field
                                                        name={inputType.title}
                                                        type="text"
                                                        className="custom-input-company-main"
                                                        placeholder={inputType.title}
                                                        key={"field" + inputType.id}
                                                        maxLength="700"
                                                        pattern="\d*"
                                                    >
                                                        {({field, form}) => (
                                                            <div className="control has-icons-right">
                                                                <div className="company-info-input-wrapper">
                                                                    <input
                                                                        className="custom-input-company-main"
                                                                        placeholder={inputType.title}
                                                                        {...field}
                                                                        onChange={e => {
                                                                            const validatedValue = e.target.value.replace(/[^\d]/g, '');
                                                                            form.setFieldValue(field.name, validatedValue);
                                                                            removeDataFromIntegrationFields(field.name)
                                                                        }}
                                                                    />
                                                                    <div>

                                                                        <div>
                                                                            <Tooltip
                                                                                title={
                                                                                    field.value.length === 0 ? `გთხოვთ შეიყვანოთ ${inputType.title}` :
                                                                                        !(field.value.length === 9 || field.value.length === 11) ? `${inputType.title} უნდა იყოს 9 ნიშნა ან 11 ნიშნა!`
                                                                                            : !/^\d+$/.test(field.value) ? `${inputType.title} უნდა შეიცავდეს მხოლოდ ციფრებს!`
                                                                                                : ""
                                                                                }>
                                                                                <span>
                                                                                    {isMobile ? (
                                                                                        <div
                                                                                            className={`identification-search-icon${!(field.value.length === 9 || field.value.length === 11) || !/^\d+$/.test(field.value) ? " disabled" : ""}`}
                                                                                            onClick={() => /^\d+$/.test(field.value) && (field.value.length === 9 || field.value.length === 11) && fetchCompanyInfo(field.value, inputType.title)}
                                                                                        >ძიება</div>
                                                                                    ) : (
                                                                                        <FaSearch
                                                                                            className={`identification-search-icon${!(field.value.length === 9 || field.value.length === 11) || !/^\d+$/.test(field.value) ? " disabled" : ""}`}
                                                                                            onClick={() => /^\d+$/.test(field.value) && (field.value.length === 9 || field.value.length === 11) && fetchCompanyInfo(field.value, inputType.title)}
                                                                                        />
                                                                                    )}

                                                                                </span>
                                                                            </Tooltip>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Field>


                                                    <ErrorMessage name={inputType.title} render={renderError}/>
                                                </div>
                                            </div>
                                        );
                                    } else if (inputType.type === 2) {
                                        return (
                                            <div className="field" key={"div" + inputType.id}>
                                                <div style={{display: "flex", gap: 10}}>
                                                    <label className="label-font" id={`input${index + 1}`}
                                                           htmlFor={inputType.title}>{inputType.title}</label>
                                                    {inputType.required && (
                                                        <div title={"სავალდებულო"}>
                                                            <FaAsterisk className="required-icon"/>
                                                        </div>
                                                    )}

                                                    {inputType.description && inputType.description !== "" && (
                                                        <div title={inputType.description}>
                                                            <FaInfoCircle
                                                                onClick={() => handleOpenDialog(inputType.description, inputType.title)}
                                                                className={"input-info-icon"}/>

                                                        </div>
                                                    )}

                                                </div>
                                                <div className="control">
                                                    <Field
                                                        name={inputType.title}
                                                        as="textarea"
                                                        className="custom-input-oldTextArea"
                                                        placeholder={inputType.title}
                                                        key={"field" + inputType.id}
                                                    />
                                                    <ErrorMessage name={inputType.title} render={renderError}/>
                                                </div>
                                            </div>
                                        );
                                    } else if (inputType.type === 3) {
                                        return (

                                            <div className="field" key={"div" + inputType.id}>
                                                <div style={{display: "flex", gap: 10}}>
                                                    <label className="label-font" id={`input${index + 1}`}
                                                           htmlFor={inputType.title}>{inputType.title}</label>

                                                    <div
                                                        title={inputType.title}>
                                                        <FaInfoCircle
                                                            onClick={() => handleOpenDialog(inputType.title, inputType.title)}
                                                            className={"input-info-icon"}/>
                                                    </div>
                                                </div>

                                                <div className="control">
                                                    {inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი" ? (
                                                            <div>
                                                                {exploitationCompanyValidationEnabled ? (
                                                                    <Tooltip title={"არარედაქტირებადი!"}>
                                                                        <span>
                                                                            <Field
                                                                                name={inputType.title}
                                                                                type="text"
                                                                                className="custom-input-company"
                                                                                placeholder={inputType.title}
                                                                                key={"field" + inputType.id}
                                                                                disabled={true}
                                                                                value={exploitationCompanyInfo[inputType.integrationPropertyName] || ''}
                                                                            />
                                                                        </span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <span>
                                                                        <Field
                                                                            name={inputType.title}
                                                                            type="text"
                                                                            className="custom-input"
                                                                            placeholder={inputType.title}
                                                                            key={"field" + inputType.id}
                                                                            maxLength="700"
                                                                        />
                                                                    </span>

                                                                )}
                                                                {caseHasExploitationField && (
                                                                    <>
                                                                        <div className="field">
                                                                            <div style={{
                                                                                display: "flex",
                                                                                gap: 5,
                                                                                marginTop: 15
                                                                            }}>
                                                                                <label className="label-font"
                                                                                       htmlFor="municipalityId">საკადასტრო
                                                                                    კოდი</label>
                                                                                <div
                                                                                    title={"არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი"}>
                                                                                    <FaInfoCircle
                                                                                        onClick={() => handleOpenDialog('არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი', 'საკადასტრო კოდი')}
                                                                                        className={"input-info-icon"}/>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                            >
                                                                                <Field
                                                                                    type="text"
                                                                                    className="custom-input-cadastral-object"
                                                                                    placeholder="საკადასტრო კოდი"
                                                                                    maxLength="700"
                                                                                    name="cadastralCode"
                                                                                >
                                                                                    {({field, form}) => (
                                                                                        <div
                                                                                            className="control has-icons-right">
                                                                                            <input
                                                                                                style={{
                                                                                                    border: alert.message === "საკადასტრო კოდი არასწორია" ? '1px solid red' :
                                                                                                        alert.message === "საკადასტრო კოდი უკვე დამატებულია სიაში!" ? '1px solid yellow'
                                                                                                            : "none"
                                                                                                }}
                                                                                                value={cadastralCode}
                                                                                                className="custom-input-cadastral-object"
                                                                                                placeholder={"საკადასტრო კოდი"}
                                                                                                onChange={(e) => setCadastralCode(e.target.value)}
                                                                                            />
                                                                                            <div>
                                                                                                <div>
                                                                                                    <Tooltip
                                                                                                        title={cadastralCode === "" ? "გთხოვთ შეიყვანოთ საკადასტრო კოდი" : "საკადასტრო კოდის დამატება"}
                                                                                                    >
                                                                                                        <div
                                                                                                            className="uniqueId-icon-wrapper">
                                                                                                            <FaPlus
                                                                                                                className={"input-search-button" + (cadastralCode === "" ? " disabled" : "")}
                                                                                                                onClick={() => fetchCadastralCode(cadastralCode)}
                                                                                                                style={{
                                                                                                                    cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                                                                                                    color: cadastralCode === "" ? "#ccc" : "#0e5bd0"
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </Tooltip>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </Field>
                                                                            </div>
                                                                        </div>
                                                                        {cadastralCodeArray.length > 0 && (
                                                                            <>
                                                                                <label className="label-font">არჩეული
                                                                                    საკადასტრო
                                                                                    კოდები:</label>
                                                                                <div className="casecreate-chips-container">
                                                                                    {cadastralCodeArray.map((code, index) => (
                                                                                        <Chip
                                                                                            key={index}
                                                                                            label={code}
                                                                                            onDelete={() => handleDeleteCadastralCode(code)}
                                                                                            deleteIcon={<MdClose/>}
                                                                                            className="casecreate-chips-chip"
                                                                                        />
                                                                                    ))}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )}

                                                            </div>
                                                        ) :
                                                        inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება" ? (


                                                                exploitationCompanyValidationEnabled ? (
                                                                    <Tooltip title={"არარედაქტირებადი!"}>
                                                                        <span>
                                                                            <Field
                                                                                name={inputType.title}
                                                                                type="text"
                                                                                className="custom-input-company"
                                                                                placeholder={inputType.title}
                                                                                key={"field" + inputType.id}
                                                                                disabled={true}
                                                                                value={exploitationCompanyInfo[inputType.integrationPropertyName] || ''}
                                                                            />
                                                                        </span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <span>
                                                                        <Field
                                                                            name={inputType.title}
                                                                            type="text"
                                                                            className="custom-input"
                                                                            placeholder={inputType.title}
                                                                            key={"field" + inputType.id}
                                                                            maxLength="700"
                                                                        />
                                                                    </span>
                                                                )
                                                            ) :
                                                            inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება" ? (

                                                                    exploitationCompanyValidationEnabled ? (
                                                                        <Tooltip title={"არარედაქტირებადი!"}>
                                                                            <div>
                                                                                <Field
                                                                                    name={inputType.title}
                                                                                    type="text"
                                                                                    className="custom-input-company"
                                                                                    placeholder={inputType.title}
                                                                                    key={"field" + inputType.id}
                                                                                    disabled={true}
                                                                                    value={exploitationCompanyInfo[inputType.integrationPropertyName] || ''}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <div>
                                                                            <Field
                                                                                name={inputType.title}
                                                                                type="text"
                                                                                className="custom-input"
                                                                                placeholder={inputType.title}
                                                                                key={"field" + inputType.id}
                                                                                maxLength="700"
                                                                            />
                                                                        </div>
                                                                    )

                                                                ) :
                                                                inputType.title === "ობიექტის მფლობელის დასახელება" ? (

                                                                        objectOwnerValidationEnabled ? (
                                                                            <Tooltip title={"არარედაქტირებადი!"}>
                                                                                <span>
                                                                                    <Field
                                                                                        name={inputType.title}
                                                                                        type="text"
                                                                                        className="custom-input-company"
                                                                                        placeholder={inputType.title}
                                                                                        key={"field" + inputType.id}
                                                                                        disabled={true}
                                                                                        value={objectOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                    />
                                                                                </span>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <span>
                                                                                <Field
                                                                                    name={inputType.title}
                                                                                    type="text"
                                                                                    className="custom-input"
                                                                                    placeholder={inputType.title}
                                                                                    key={"field" + inputType.id}
                                                                                    maxLength="700"
                                                                                />
                                                                            </span>
                                                                        )

                                                                    ) :
                                                                    inputType.title === "ორგანიზაციის იურიდიული მისამართი" ? (


                                                                            boomBoomOwnerValidationEnabled ? (
                                                                                <Tooltip title={"არარედაქტირებადი!"}>
                                                                                    <span>
                                                                                        <Field
                                                                                            name={inputType.title}
                                                                                            type="text"
                                                                                            className="custom-input-company"
                                                                                            placeholder={inputType.title}
                                                                                            key={"field" + inputType.id}
                                                                                            disabled={true}
                                                                                            value={boomBoomOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                        />
                                                                                    </span>
                                                                                </Tooltip>
                                                                            ) : (
                                                                                <span>
                                                                                    <Field
                                                                                        name={inputType.title}
                                                                                        type="text"
                                                                                        className="custom-input"
                                                                                        placeholder={inputType.title}
                                                                                        key={"field" + inputType.id}
                                                                                        maxLength="700"
                                                                                    />
                                                                                </span>
                                                                            )
                                                                        ) :

                                                                        inputType.title === "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია" ? (


                                                                                boomBoomOwnerValidationEnabled ? (
                                                                                    <Tooltip title={"არარედაქტირებადი!"}>
                                                                                        <span>
                                                                                            <Field
                                                                                                name={inputType.title}
                                                                                                type="text"
                                                                                                className="custom-input-company"
                                                                                                placeholder={inputType.title}
                                                                                                key={"field" + inputType.id}
                                                                                                disabled={true}
                                                                                                value={boomBoomOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                            />
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <span>
                                                                                        <Field
                                                                                            name={inputType.title}
                                                                                            type="text"
                                                                                            className="custom-input"
                                                                                            placeholder={inputType.title}
                                                                                            key={"field" + inputType.id}
                                                                                            maxLength="700"
                                                                                        />
                                                                                    </span>
                                                                                )
                                                                            ) :
                                                                            inputType.title === "ობიექტის მფლობელის იურიდიული მისამართი" ? (
                                                                                objectOwnerValidationEnabled ? (
                                                                                    <Tooltip
                                                                                        title={"არარედაქტირებადი!"}>
                                                                                        <span>
                                                                                            <Field
                                                                                                name={inputType.title}
                                                                                                type="text"
                                                                                                className="custom-input-company"
                                                                                                placeholder={inputType.title}
                                                                                                key={"field" + inputType.id}
                                                                                                disabled={true}
                                                                                                value={objectOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                            />
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <span>
                                                                                        <Field
                                                                                            name={inputType.title}
                                                                                            type="text"
                                                                                            className="custom-input"
                                                                                            placeholder={inputType.title}
                                                                                            key={"field" + inputType.id}
                                                                                            maxLength="700"
                                                                                        />
                                                                                    </span>
                                                                                )

                                                                            ) : (
                                                                                <span>
                                                                                    <Field
                                                                                        name={inputType.title}
                                                                                        type="text"
                                                                                        className="custom-input-company"
                                                                                        placeholder={inputType.title}
                                                                                        key={"field" + inputType.id}
                                                                                        disabled={true}
                                                                                        value={companyInfo[inputType.integrationPropertyName] || ''}
                                                                                    />
                                                                                </span>
                                                                            )}

                                                    <ErrorMessage name={inputType.title} render={renderError}/>
                                                </div>

                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="field" key={"div" + inputType.id}>
                                                <div style={{display: "flex", gap: 10}}>
                                                    <label className="label-font" id={`input${index + 1}`}
                                                           htmlFor={inputType.title}>{inputType.title}</label>
                                                    {inputType.required && (
                                                        <div title={"სავალდებულო"}>
                                                            <FaAsterisk className="required-icon"/>
                                                        </div>
                                                    )}
                                                    {inputType.description && inputType.description !== "" && (
                                                        <div title={inputType.description}>
                                                            <FaInfoCircle
                                                                onClick={() => handleOpenDialog(inputType.description, inputType.title)}
                                                                className={"input-info-icon"}/>

                                                        </div>

                                                    )}

                                                </div>
                                                <div className="control">
                                                    <Field
                                                        name={inputType.title}
                                                        type="text"
                                                        className="custom-input"
                                                        placeholder={inputType.title}
                                                        key={"field" + inputType.id}
                                                        maxLength="700"
                                                    />
                                                    <ErrorMessage name={inputType.title} render={renderError}/>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                                {userRole && userRole !== "ROOTADMIN" && userRole !== "USER" && (
                                    <div className="field">
                                        <label htmlFor="creteByExpertCaseNumber" className="checkbox-label">განაცხადის
                                            ნომრის
                                            მინიჭება</label>
                                        <Field checked={creteByExpertCaseNumber}
                                               onChange={(e) => setCreteByExpertCaseNumber(e.target.checked)}
                                               type="checkbox"
                                               name="creteByExpertCaseNumber"/>
                                        <ErrorMessage name="creteByExpertCaseNumber" component="div" className="error"/>
                                    </div>
                                )}

                                {creteByExpertCaseNumber && (
                                    <div className="field">
                                        <label htmlFor="oldCaseNumber" className="label-font">ძველი საქმის
                                            ნომერი</label>
                                        <div className="control">
                                            <Field name="oldCaseNumber" type="text" className="custom-input"
                                                   placeholder="შეიყვანეთ ნომერი"/>
                                        </div>
                                        <ErrorMessage name="oldCaseNumber" render={renderError}/>
                                    </div>
                                )}

                                {showAccelerationCheckbox && (
                                    <div className="field">
                                        <label className="checkbox-acc">
                                            <Field
                                                type="checkbox"
                                                name="acceleration"
                                                checked={isAccelerationChecked}
                                                onChange={() => setIsAccelerationChecked(!isAccelerationChecked)}
                                            />
                                            დაჩქარება
                                        </label>
                                    </div>
                                )}

                                {isAccelerationChecked && (
                                    <div className="field">
                                        <label className="label-font" htmlFor="permitTypePriceId">დაჩქარება</label>
                                        <div className="control">
                                            <Field name="permitTypePriceId">
                                                {({field, form}) => (
                                                    <Select
                                                        options={permitTypePricings.map(p => ({
                                                            value: p.id,
                                                            label: `${p.days} დღე - ${p.price}
                                                            `
                                                        }))}
                                                        name="permitTypePriceId"
                                                        value={permitTypePricings.find(option => option.value === field.value)}
                                                        onChange={option => {
                                                            form.setFieldValue("permitTypePriceId", option.value);
                                                            setSelectedPermitTypePriceId(option.value);
                                                        }}
                                                        styles={customStyles}
                                                        isSearchable
                                                    />
                                                )}

                                            </Field>
                                            <ErrorMessage name="permitTypePriceId" component="div"
                                                          className="help is-danger"/>


                                        </div>
                                    </div>
                                )}
                                <Tooltip title={(!isValid) ? "შეავსეთ ყველა სავალდებულო ველი" : ""}>
                                    <div>
                                        <button
                                            type="submit"
                                            className="customButton"
                                            disabled={
                                                userRole === 'USER' && (
                                                    !isValid ||
                                                    !dirty ||
                                                    (isObjectInfoButtonDisabled && objectOwnerValidationEnabled) ||
                                                    (userFirstName === '' && isPhysical) ||
                                                    (isExplanationInfoButtonDisabled && exploitationCompanyValidationEnabled) ||
                                                    (isBoomBoomInfoButtonDisabled && boomBoomOwnerValidationEnabled) ||
                                                    (isCompanyInfoButtonDisabled && companyValidationEnabled)
                                                )
                                            }
                                        >
                                            გაგზავნა
                                        </button>

                                    </div>
                                </Tooltip>
                            </Form>
                        )}
                    </Formik>
                </div>
            ))}

            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={closeConfirmationModal}
                onConfirm={handleFormSubmit}
            />
        </div>
    );
};

export default DashboardApplicationComponent;
